import L from 'leaflet';

import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

export const defaultFieldMapIcon = L.icon({
  iconUrl: markerIcon,
  iconRetinaUrl: markerIcon2x,
  shadowUrl: markerShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
});

/** Labeled marker layout: pin on top, label below. Tip of pin is the lat/lng anchor. */
const LABELED_ICON_WIDTH = 140;
const LABELED_PIN_HEIGHT = 41;
const LABELED_LABEL_GAP = 2;
const LABELED_LABEL_MAX_HEIGHT = 36;
const LABELED_ICON_HEIGHT = LABELED_PIN_HEIGHT + LABELED_LABEL_GAP + LABELED_LABEL_MAX_HEIGHT;

/** Red pin matching leaflet default marker size (25×41), tip at bottom-center. */
const SELECTED_PIN_SVG = encodeURIComponent(
  `<svg xmlns="http://www.w3.org/2000/svg" width="25" height="41" viewBox="0 0 25 41">
    <path fill="#d32f2f" stroke="#8e0000" stroke-width="1"
      d="M12.5 0C5.6 0 0 5.6 0 12.5 0 21.9 12.5 41 12.5 41S25 21.9 25 12.5C25 5.6 19.4 0 12.5 0z"/>
    <circle fill="#fff" cx="12.5" cy="12.5" r="5.5"/>
  </svg>`,
);
const SELECTED_PIN_URL = `data:image/svg+xml;charset=UTF-8,${SELECTED_PIN_SVG}`;

/** Red pin for scenario location (distinct from blue catalogue field markers). */
const SCENARIO_PIN_SVG = encodeURIComponent(
  `<svg xmlns="http://www.w3.org/2000/svg" width="25" height="41" viewBox="0 0 25 41">
    <path fill="#d32f2f" stroke="#8e0000" stroke-width="1"
      d="M12.5 0C5.6 0 0 5.6 0 12.5 0 21.9 12.5 41 12.5 41S25 21.9 25 12.5C25 5.6 19.4 0 12.5 0z"/>
    <circle fill="#fff" cx="12.5" cy="12.5" r="5.5"/>
  </svg>`,
);
const SCENARIO_PIN_URL = `data:image/svg+xml;charset=UTF-8,${SCENARIO_PIN_SVG}`;

function escapeHtml(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

export function createLabeledFieldMapIcon(label: string, selected = false): L.DivIcon {
  const safeLabel = escapeHtml(label);
  const selectedClass = selected ? ' field-map-labeled-marker--selected' : '';
  const pinSrc = selected ? SELECTED_PIN_URL : markerIcon;
  return L.divIcon({
    className: 'field-map-labeled-marker',
    html: `
      <div class="field-map-labeled-marker__wrap${selectedClass}">
        <img class="field-map-labeled-marker__pin" src="${pinSrc}" width="25" height="41" alt="" draggable="false" />
        <div class="field-map-labeled-marker__label">${safeLabel}</div>
      </div>
    `,
    // Anchor at the pin tip (bottom-center of the 25×41 image), not the box bottom.
    iconSize: [LABELED_ICON_WIDTH, LABELED_ICON_HEIGHT],
    iconAnchor: [LABELED_ICON_WIDTH / 2, LABELED_PIN_HEIGHT],
  });
}

export function createScenarioLocationMapIcon(label = 'Scenario'): L.DivIcon {
  const safeLabel = escapeHtml(label);
  return L.divIcon({
    className: 'field-map-labeled-marker scenario-location-marker',
    html: `
      <div class="field-map-labeled-marker__wrap field-map-labeled-marker--scenario">
        <img class="field-map-labeled-marker__pin" src="${SCENARIO_PIN_URL}" width="25" height="41" alt="" draggable="false" />
        <div class="field-map-labeled-marker__label">${safeLabel}</div>
      </div>
    `,
    iconSize: [LABELED_ICON_WIDTH, LABELED_ICON_HEIGHT],
    iconAnchor: [LABELED_ICON_WIDTH / 2, LABELED_PIN_HEIGHT],
  });
}
